import BaseServiceHttp from '../baseService'
class FormatosExemplares extends BaseServiceHttp {
  constructor(id) {
    const resource = 'formatos-exemplares'
    const relationship = {}
    const baseURL = process.env.REACT_APP_API_URL
    super(id, resource, relationship, baseURL)
  }
}

export default id => new FormatosExemplares(id)
